import { ShieldCheck, Star } from "lucide-react";

export function Stars({ n = 5 }) {
  const c = Math.max(0, Math.min(5, n || 0));
  return (
    <div className="flex items-center gap-0.5" aria-label={`${c} out of 5`}>
      {[...Array(5)].map((_, i) => (
        <Star key={i} size={13} className={i < c ? "text-white fill-white" : "text-white/15"} strokeWidth={1.5} />
      ))}
    </div>
  );
}

function fmtTime(value) {
  if (!value) return "TIME UNKNOWN";
  try {
    return new Date(value).toLocaleString(undefined, { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" }).toUpperCase();
  } catch {
    return "TIME UNKNOWN";
  }
}

export default function VouchCard({ v, fresh = false }) {
  const author = v.author_name || "ANONYMOUS";
  const product = (v.product_slug || "injectd-multi").replace(/-/g, " ").toUpperCase();
  const id = String(v.message_id || "LOG").slice(-8).toUpperCase();

  return (
    <article className={`terminal-vouch p-5 mb-6 font-mono${fresh ? " vouch-transmission" : ""}`} data-testid="vouch-card">
      <div className="flex items-center justify-between gap-3 border-b border-white/10 pb-3">
        <div className="min-w-0">
          <div className="text-[11px] tracking-[0.16em] text-white/85 truncate">
            &gt; USER: {author.toUpperCase()}
          </div>
          <div className="mt-1 text-[9px] tracking-[0.2em] text-white/30">
            LOG_{id} // {fmtTime(v.timestamp)}
          </div>
        </div>
        <span className="inline-flex shrink-0 items-center gap-1.5 border border-white/25 bg-white/5 px-2 py-1 text-[9px] tracking-[0.18em] text-white/70">
          <ShieldCheck size={11} /> VERIFIED
        </span>
      </div>

      <div className="mt-4 flex gap-3">
        <img
          src={v.avatar_url}
          alt=""
          onError={(e) => { e.currentTarget.src = "https://cdn.discordapp.com/embed/avatars/0.png"; }}
          className="h-9 w-9 shrink-0 border border-white/15 object-cover grayscale"
        />
        <div className="min-w-0 flex-1">
          <div className="text-[10px] tracking-[0.18em] text-white/35">$ PRINT REVIEW</div>
          <p className="mt-2 whitespace-pre-line text-[13px] leading-relaxed text-white/72">
            {v.content || "[MEDIA ATTACHED]"}
          </p>
        </div>
      </div>

      {v.images && v.images.length > 0 && (
        <div className="mt-4 grid gap-2">
          {v.images.slice(0, 2).map((img, i) => (
            <img key={i} src={img} alt="" className="max-h-72 w-full border border-white/10 object-cover grayscale transition-[filter] duration-500 hover:grayscale-0" />
          ))}
        </div>
      )}

      <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-white/[0.07] pt-3">
        <span className="text-[9px] tracking-[0.18em] text-white/40">[TAG: {product}]</span>
        {v.rating != null ? <Stars n={v.rating} /> : <span className="text-[9px] tracking-[0.18em] text-white/30">RATING: N/A</span>}
      </div>
    </article>
  );
}
